import { Controller } from "@hotwired/stimulus"

// FD-642: the update-schedule form has three recurrence kinds with different
// fields (weekday picker / day-of-month / nth+weekday). A strict CSP forbids
// inline handlers, so the kind <select> drives this tiny toggle instead:
//   data-controller="schedule-fields" data-action="change->schedule-fields#toggle"
// Each field group declares data-schedule-fields-target and data-kinds (a
// space-separated list of the kinds it belongs to). A group that does not apply
// takes the native hidden attribute, which the view also starts it with.
export default class extends Controller {
  static targets = ["group", "kind"]

  connect() { this.toggle() }

  toggle() {
    const kind = this.kindTarget.value
    this.groupTargets.forEach((group) => {
      group.hidden = !group.dataset.kinds.split(" ").includes(kind)
    })
  }
}
